import { render } from "./ContractSettings.vue?vue&type=template&id=561dac3e&scoped=true"
import script from "./ContractSettings.vue?vue&type=script&lang=js"
export * from "./ContractSettings.vue?vue&type=script&lang=js"

import "./ContractSettings.vue?vue&type=style&index=0&id=561dac3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561dac3e"]])

export default __exports__